module.exports = __webpack_public_path__ + "img/contacts-csv.c5db4381.png";